import { jsx as m } from "react/jsx-runtime";
import { clsx as s } from "../../utils/clsx.js";
import { s as a } from "../../Button.module-Z6njvP9Z.js";
function e(r) {
  const {
    children: o,
    className: t
  } = r;
  return /* @__PURE__ */ m("div", { className: s(a.bar, t), children: o });
}
export {
  e as ButtonBar
};
